import { render, staticRenderFns } from "./CrmPayway.vue?vue&type=template&id=b1f0dffc&"
import script from "./CrmPayway.vue?vue&type=script&lang=js&"
export * from "./CrmPayway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports